import { IconProps } from '../icon';

export function SouligneIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 255.54 217.27"
      {...props}
    >
      <g id="a" />
      <g id="b">
        <g id="c">
          <g>
            <path d="M178.89,0h25.86c0,2.03,0,3.81,0,5.58,0,27.33,.03,54.66,0,81.98-.06,39.12-25.35,69.84-63.77,77.56-41.48,8.33-84.78-23.5-89.19-65.64-.55-5.29-.83-10.63-.85-15.94-.08-27.65-.04-55.3-.04-83.37h25.86c0,1.73,0,3.64,0,5.55,0,27.99-.08,55.99,.03,83.98,.1,26.23,19.25,47.33,45.81,50.75,24.22,3.12,48.58-13.87,54.74-38.45,1.12-4.46,1.46-9.21,1.49-13.83,.13-27.49,.07-54.99,.07-82.48,0-1.79,0-3.57,0-5.68Z" />
            <path d="M0,217.27v-25.2H255.54v25.2H0Z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SouligneIcon;
